import { Select, SelectProps } from '@mantine/core';

import { useGetCitiesQuery } from '@api/locations.api';

export default function CitySelector(
  props: { province: string } & SelectProps,
) {
  const { data = [], isLoading } = useGetCitiesQuery(props.province, {
    skip: props.disabled,
  });

  return (
    <Select
      label="Città"
      placeholder="Seleziona città"
      data={data
        .toSorted((a, b) => (a.nome > b.nome ? 1 : -1))
        .map((city) => ({
          value: city.nome,
          label: city.nome,
        }))}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
